export default {
      id: "jobs-usage",
      viewBox: "0 0 76 80",
      url: "../dist/images/" + "sprite.svg#jobs-usage",
      toString: function () {
        return this.url;
      }
    }